import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PaginationConfig } from '../../../shared/configs/paginator.config';
import { SnackBarConfig } from '../../../shared/configs/snackbar.config';
import { IWarehouseGroup } from '../../../shared/interfaces/location-warehouse.interface';
import { IPagination } from '../../../shared/interfaces/paginator.interface';
import { LocationWarehouseGroupApiService } from '../../../shared/services/api/location/location-warehouse-group-api.service';

// INTERFACES

@Component({
  selector: 'lum-setting-warehouse-group-inventory-numbers',
  templateUrl: './setting-warehouse-group-inventory-numbers.component.html',
  styleUrls: ['./setting-warehouse-group-inventory-numbers.component.scss'],
})
export class SettingWarehouseGroupInventoryNumbersComponent
  implements OnInit, OnDestroy
{
  data :IWarehouseGroup[] = [];

  loading :boolean = false;

  paginationConfig = PaginationConfig;
  pagination :IPagination = {
    current_page: 1,
    from: null,
    last_page: 1,
    path: '',
    per_page: PaginationConfig.perPage,
    to: null,
    total: 0,
  };

  queryParams :{ [param :string] :string | string[] };
  searchQuery :string = '';

  private onDestroy$ = new Subject();

  constructor(
    private warehouseGroupService :LocationWarehouseGroupApiService,
    private cd :ChangeDetectorRef,
    private snackBar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    this.initQueryParams();
    this.loadData();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onPaginationEvent(pagination :PageEvent) :void {
    this.queryParams = {
      ...this.queryParams,
      limit: pagination.pageSize.toString(),
      page: (pagination.pageIndex + 1).toString(),
    };
    this.loadData();
  }

  onToggleEvent(id :number) :void {
    this.warehouseGroupService
      .updateInventoryNumbersSettings(id)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response) => {
          this.snackBar.open(
            'Warehouse group inventory numbers setting updated',
            'Success',
            {
              duration: SnackBarConfig.DEFAULT.duration,
            },
          );
          this.loadData();
        },
        error: (response) => {
          this.snackBar.open(response.error, 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
          this.cd.detectChanges();
        },
      });
  }

  private initQueryParams() :void {
    this.queryParams = {
      limit: PaginationConfig.perPage.toString(),
      page: PaginationConfig.page.toString(),
      sortDirection: 'desc',
      sortField: 'created_at',
    };
  }

  private loadData() :void {
    this.loading = true;
    this.warehouseGroupService
      .getWarehouseGroups({
        ...this.queryParams,
        searchQuery: this.searchQuery,
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.data = response?.data;
          this.pagination = response?.meta;
          this.cd.detectChanges();
        },
        error: (response) => {
          this.loading = false;
          this.snackBar.open(response.error, 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
          this.cd.detectChanges();
        },
      });
  }
}
